import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'
import store from '~/store'
import ua from '~/language/ua.json'

function unflatten(data) {
  const result = {}

  // Сортируем ключи по длине, чтобы более короткие ключи обрабатывались первыми
  const sortedKeys = Object.keys(data).sort((a, b) => a.split('.').length - b.split('.').length)

  sortedKeys.forEach((flatKey) => {
    const keys = flatKey.split('.')
    let current = result

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      const isLastKey = i === keys.length - 1

      if (isLastKey) {
        // Если это ключ-примитив, который может конфликтовать с объектом,
        // сохраняем его в специальном свойстве _value
        if (current[key] && typeof current[key] === 'object' && current[key] !== null) {
          // Уже есть объект, сохраняем примитив в _value
          if (!('_value' in current[key])) {
            current[key]._value = data[flatKey]
          }
        } else {
          // Устанавливаем обычное значение
          current[key] = data[flatKey]
        }
      } else {
        // Промежуточный ключ
        if (!(key in current)) {
          current[key] = {}
        } else if (typeof current[key] !== 'object' || current[key] === null) {
          // Превращаем примитив в объект, сохраняя старое значение в _value
          const oldValue = current[key]
          current[key] = { _value: oldValue }
        }
        current = current[key]
      }
    }
  })

  return result
}

const i18n = createI18n({
  locale: 'ua',
  globalInjection: true,
  fallbackLocale: 'ua',
  messages: { ua: unflatten(ua) },
  missing: (locale, key) => {
    console.warn(`[i18n] missing translation: ${locale}.${key}`)
    return key
  },
  messageResolver: (obj, path) => {
    const keys = path.split('.')
    let current = obj
    
    for (const key of keys) {
      if (current == null) {
        return null
      }
      current = current[key]
    }
    
    if (typeof current === 'object' && current !== null && '_value' in current) {
      return current._value
    }
    
    return current
  }
})

export function setI18nLanguage(locale) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  document.documentElement.setAttribute('lang', locale)
}

export async function loadLocaleMessages(locale) {
  const messagesModule = await import(`~/language/${locale}.json`)
  i18n.global.setLocaleMessage(locale, unflatten(messagesModule.default))
  setI18nLanguage(locale)
  store.dispatch('lang/setLocale', { locale })
  return nextTick()
}

; (async () => {
  const saved = store.getters['lang/locale']
  setI18nLanguage(saved)
  await loadLocaleMessages(saved)
})()

export default i18n
